import { ParsedUrlQuery } from "querystring"
import { GetStaticPropsContext } from "next"
import {
  default as TeamPageDestination,
  getStaticProps as getStaticPropsDestination,
  IParams as IParamsDestination,
} from "./campionato/[competitionCalciocomSlug]/stagione/[seasonCalciocomSlug]/formazione"
import { getRedirectTeamInfo } from "../../../src/utils/team"

export default TeamPageDestination

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" }
}

interface IParams extends ParsedUrlQuery {
  teamCalciocomSlug: string
}

export async function getStaticProps(context: GetStaticPropsContext<IParams>) {
  try {
    const { teamCalciocomSlug } = context.params!

    const { competition, season } = await getRedirectTeamInfo(teamCalciocomSlug)

    const destinationContext: GetStaticPropsContext<IParamsDestination> = {
      params: {
        teamCalciocomSlug: teamCalciocomSlug,
        competitionCalciocomSlug: competition.calciocomSlug!,
        seasonCalciocomSlug: season.calciocomSlug!,
      },
    }

    return getStaticPropsDestination(destinationContext, true)
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }
}
